module.exports = __webpack_public_path__ + "static/icon-6642b5644c8129e67fb13d0e63d2086f.png";